import * as yup from 'yup';

export const WoundAttachmentShcema = yup.object({
  type: yup.string().required(),
  woundId: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export const DownloadWoundAttachmentSchema = yup.object({
  woundId: yup.string().required(),
  awsFilePath: yup.string().required(),
});

export const UpdateWoundAttachmentSchema = yup.object({
  id: yup.string(),
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export const CreateWoundAttachmentSchema = yup.object({
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export interface IWoundAttachmentCreate {
  type: string;
  information: string | null;
  originDate: Date;
}

export interface IWoundAttachment {
  id: string;
  type: string;
  woundId: string;
  information: string | null;
  originDate: Date;
  createdAt: Date;
  fileName: string;
  awsFilePath: string;
}

export interface IUpdateWoundAttachment extends IWoundAttachmentCreate {
  id: string;
}
